export enum PeriodIssueState {
    OPEN = 0,
    RESOLVED_AUTOMATICALLY = 1,
    DENIED_BY_ACCOUNTANT = 2
}
